
import HowToDonate from "../components/ourAlumni/howToDonate"
import LoyaltyScheme from "../components/ourAlumni/loyaltyScheme"
import { useSelector } from 'react-redux';
import { DecodeHtml } from "../utils/decodeHtml";

const GiveToUniten = () => {
    const state = useSelector(state => state.ourAlumniCommunity)
    const ourAlumni = state?.data?.properties

    const title = ourAlumni?.fourthMainTitle
    const description = ourAlumni?.fourthMainDescription
    const subTitle = ourAlumni?.fourthMainSubTitle

    const list = ourAlumni?.praticesList?.map((item) => {
        return item
    })
    const accordionTexts = ourAlumni?.accordions?.items?.map((item) => {
        item = item?.content?.properties
        return {
            title: item?.label,
            contents: DecodeHtml({html:item?.accordionContent?.markup})
        }
    }
    )
    return (
        <div className="flex justify-center md:py-8 w-full">
            <div className="flex flex-col 2xl:gap-32 max-w-7xl lg:px-16 2xl:px-0 mb-12">

                <LoyaltyScheme />
                <div className="flex flex-col items-center justify-center gap-4 p-6 lg:p-0">
                    <h1 className="w-auto  text-slate-900 text-3xl md:text-5xl font-bold">{title}</h1>
                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{description}</p>
                    {/* <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">UNITEN is committed to working with donors and potential donors to understand their motivation and vision for the donations they make or intend to make to us.</p> */}
                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{subTitle}</p>
                    <ul className="flex flex-col items-center justify-center self-center list-disc ">
                        {
                            list?.map((item, index) => (
                                <li key={index} className="w-auto  text-sky-950 text-center text-opacity-70 text-base font-bold leading-normal">{item}</li>
                            ))
                        }
                    </ul>
                </div>
                <HowToDonate accordionTexts={accordionTexts} />
            </div>
        </div>
    )
}

export default GiveToUniten